// @flow
/* eslint-disable react/no-unused-prop-types */

import * as React from 'react';

import clsx from 'clsx';

import { useTranslator } from '@gandi/translate';
import { Base, Interactive } from '@gandi/ui';

import styles from './SkipLinks.scss';

export type Props = {
  className?: string,
  href?: string,
  to?: string,
  children?: React$Node,
};

function Link(props: Props) {
  return (
    <Interactive
      paddingY="xsmall"
      paddingX="small"
      weight="regular"
      color="white"
      backgroundColor="green"
      hoverBackgroundColor="green-dark"
      interactive
      className={styles.link}
      {...props}
    />
  );
}

function SkipLinks({ className }: Props): React.Node {
  const { __ } = useTranslator();

  return (
    <Base
      boxSizing="border"
      paddingY="xsmall"
      paddingX="small"
      backgroundColor="white"
      className={clsx(styles.root, className)}
    >
      <Base flex flexWrap className={styles.wrapper} data-nosnippet>
        <Link href="#layout-main-navigation">
          {__('Skip to main navigation')}
        </Link>
        <Link href="#layout-main-content">{__('Skip to main content')}</Link>
      </Base>
    </Base>
  );
}

export { SkipLinks };
